import { FinishedGood } from '@interfaces/finished-good';
import { getCall } from '@services/rest-service';

// Retrieves all the finished goods from cosmos
export const getFinishedGoods = (): Promise<FinishedGood[]> => {
  return getCall<FinishedGood[]>('finished-goods');
};